import { createReducer, on } from "@ngrx/store";
import { loadItemsSuccess, loadItemsFailure, addItem, updateItem, loadCompanyLedgersSuccess, loadCompanyLedgersFailure, deleteItem } from "./item.actions";

export interface ItemState {
    items: any[];
    itemLedgers: any[];
    lastUpdatedBy?: { id: number; source: 'http' | 'signalr' };
    error: string | null;
  }
  
  const initialState: ItemState = {
    items: [],
    itemLedgers: [],
    error: null,
  };

  export const itemReducer = createReducer(
    initialState,
    on(loadItemsSuccess, (state, { items }) => ({
      ...state,
      items,
      error: null,
    })),
    on(loadItemsFailure, (state, { error }) => ({
      ...state,
      error,
    })),
    on(addItem, (state, { item }) => ({
      ...state,
      items: [...state.items, item],
      error: null
    })),
    on(updateItem, (state, { item, source }) => {
      if (state.lastUpdatedBy && state.lastUpdatedBy.id == item.itemID && state.lastUpdatedBy.source !== source) {
        return { ...state, lastUpdatedBy: undefined };
      }

      return {
        ...state,
        items: state.items.map(i =>
          i.itemID === item.itemID ? { ...i, ...item } : i
        ),
        lastUpdatedBy: { id: item.itemID, source },
        error: null
      }
    }),
    on(deleteItem, (state, { itemId, source }) => {
      if (state.lastUpdatedBy && state.lastUpdatedBy.id == itemId && state.lastUpdatedBy.source !== source) {
        return { ...state, lastUpdatedBy: undefined };
      }

      return {
        ...state,
        items: state.items.filter(i => i.itemID != itemId),
        lastUpdatedBy: { id: itemId, source },
      }
    }),
    on(loadCompanyLedgersSuccess, (state, { itemLedgers }) => ({
      ...state,
      itemLedgers,
      error: null,
    })),
    on(loadCompanyLedgersFailure, (state, { error }) => ({
      ...state,
      error,
    }))
  );